const persons = {
  title: "Kontakter",
  new_person: "Ny kontakt",
  edit_person: "Rediger kontakt: {name}",
  view_person: "Vis kontakt: {name}",
  person_title: "Kontakt detaljer",
  list_title: "Kontakter",
  list_subtitle: "Håndter kontakter",
  overview: "Kompetanse",
  qrcode_title: "QR kode",
  id: "ID",
  first_name: "Fornavn",
  last_name: "Etternavn",
  middle_name: "Mellomnavn",
  mobile: "Mobil",
  email: "Epost",
  date_of_birth: "Fødselsdato",
  comments: "Kommentarer",
  create_as_user: "Opprett som bruker",
  employeed_from: "Ansatt fra",
  employed_to: "Employed To",
  dob: "F.d.",
  company: "Selskap",
  street: "Adresse",
  city: "Sted",
  state: "Fylke",
  zip: "Postnr",
  country: "Land",
  image: "Bilde",
  upload_image: "Last opp bilde",
  select_image: "Velg bilde",
  last_updated_sync: "Sist synkronisert",
  qr_generate: "Generer QR kode",
  student_1_image: "Bruk bilde 1",
  student_2_image: "Bruk bilde 2",
  merge_to_existing: "Slå sammen med eksisterende elev",
  merge_th_field: "Felt",
  merge_existing_user: "Eksisterende elev",
  merge_new_user: "Ny elev",
  merge_th_result: "Resultat",
}
export default persons
